import React from 'react';
import NavigationBar from './NavigationBar';
import TabContent from './TabContent';
import commonUtil from './../../../utils/commonUtil';
// import style from './ui_component_tabs_custom.css';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this._init = this._init.bind(this);

    this.state = {
      selectedTab: props.selectedTab || null
    };
  }
  getClassForTabLinks = (length) => {
    if (commonUtil.getChannel().toUpperCase() === 'WAP') {
      const grid = (12 / length);
      return 'col-sm-' + grid + ' col-xs-' + grid + ' col-md-' + grid + ' col-lg-' + grid;
    }
    return null;
  }
  componentDidMount() {
    this._init();
  }

  _getHash = (url) => {
    const hashPos = url.lastIndexOf('#');
    return url.substring(hashPos + 1);
  }
  _showTab = (tabLink, _tabLinks, _contentDivs) => {
    const selectedId = this._getHash(tabLink.getAttribute('href'));
    const tabLinks = _tabLinks;
    const contentDivs = _contentDivs;
    // Highlight the selected tab, and dim all others.
    // Also show the selected content div, and hide all others.
    const tabClass = this.getClassForTabLinks(Object.keys(_contentDivs).length);
    /* eslint-disable */
    for (let id in contentDivs) {
      if (id === selectedId) {
        tabLinks[id].className = 'selected';
        tabLinks[id].parentNode.className = tabClass + ' active navigation-bar-tab';
        contentDivs[id].className = 'tab-pane active';
      } else {
        tabLinks[id].className = '';
        tabLinks[id].parentNode.className = tabClass + ' navigation-bar-tab inactive';
        contentDivs[id].className = 'tab-pane';
      }
    }
    /* eslint-enable */
    // Stop the browser following the link

    // Update selectedTab state
    this.setState({ selectedTab: selectedId }, () => {
      if (this.props.callbackAfterTabChanging) {
        this.props.callbackAfterTabChanging(selectedId);
      }
    });

    return false;
  }
  _getFirstChildWithTagName = (element, tagName) => {
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes[i].nodeName === tagName) {
        return element.childNodes[i];
      }
    }
    return null;
  }
  _init = () => {
    const self = this;
    this.tabLinks = [];
    this.contentDivs = [];
    // Grab the tab links and content divs from the page
    const tabListItems = document.getElementById('tabs').childNodes;
    for (let i = 0; i < tabListItems.length; i++) {
      if (tabListItems[i].nodeName === 'LI') {
        const tabLink = this._getFirstChildWithTagName(tabListItems[i], 'A');
        if (tabLink !== undefined && tabLink !== null && tabLink.classList && tabLink.classList.contains('enabled')) {
          const id = this._getHash(tabLink.getAttribute('href'));
          this.tabLinks[id] = tabLink;
          this.contentDivs[id] = document.getElementById(id);
        }
      }
    }
    // Assign onclick events to the tab links, and
    // highlight the first tab
    let i = 0;
    /* eslint-disable */
    for (const id in this.tabLinks) {
      this.tabLinks[id].onclick = function () {
        return self._showTab(self.tabLinks[id], self.tabLinks, self.contentDivs);
      };
      this.tabLinks[id].onfocus = () => {
        this.tabLinks[id].blur();
      };
      const tabClass = this.getClassForTabLinks(Object.keys(this.tabLinks).length);
      if (this.props.selectedTab) {
        if (id === this.props.selectedTab) {
          this.tabLinks[this.props.selectedTab].className = 'selected';
          this.tabLinks[this.props.selectedTab].parentNode.className = tabClass + ' active navigation-bar-tab';
          this.setState({ selectedTab: this.props.selectedTab }); // sync state
        } else {
          this.tabLinks[id].parentNode.className = tabClass + ' navigation-bar-tab inactive';
        }
      } else {
        if (i === 0) {
          this.tabLinks[id].className = 'selected';
          this.tabLinks[id].parentNode.className = tabClass + ' active navigation-bar-tab';
          this.setState({ selectedTab: id }); // first tab as default
        } else {
          this.tabLinks[id].parentNode.className = tabClass + ' navigation-bar-tab inactive';
        }
      }
      i += 1;
    }
    /* eslint-enable */
    // Hide all content divs except the first
    let k = 0;
    for (let id = 0; id < this.contentDivs.length; id++) {
      if (k !== 0) this.contentDivs[id].className = 'tab-pane';
      k += 1;
    }
  }

  render() {
    // this._init();
    return (
      <div className={this.props.cssClass}>
        <NavigationBar {...this.props} tabSelected={this.state.selectedTab} />
        <TabContent {...this.props} />
      </div>

    );
  }
}

export default Tabs;
